import CryptoJS from "crypto-js";
import { REACT_APP_EncryptionKey } from "../Config/config";
export const encryptData = (data) => {
  const encryptedData = CryptoJS.AES.encrypt(
    data,
    REACT_APP_EncryptionKey
  ).toString();
  return encryptedData;
};
